export interface IGetPropertyConfigParams {
  propertyId: number
  checkInDate?: string
  reservationDate?: string
}

export interface IGetPropertyConfigResponse {
  propertyId: number
  promotions?: string[]
  tags?: string[]
  badges?: string[]
  filters?: string[]
  hideView?: string[]
  policies?: string[]
  control: {
    reservation: boolean
    ratePlan: boolean
    globalSales: boolean
    parking: boolean
    hideWeb: boolean
    selfCheckIn: boolean
    channelPromotion: boolean
    priceClaim: boolean
  }
  parking?: {
    full: boolean
    date: string
  }
}

export interface IGetRoomTypeConfigParams {
  roomTypeId: number
  checkInDate?: string
}

export enum ProductConfigControlParking {
  NO_PARKING_LOT = 'NO_PARKING_LOT',
  WALKING_ONLY = 'WALKING_ONLY',
  PARKING_AVAILABLE = 'PARKING_AVAILABLE',
}

export type TGetRoomTypeConfigResponse = Omit<IGetPropertyConfigResponse, 'hideView' | 'policies'> &
  (
    | {
        roomTypeId: number
        control: {
          reservation: boolean
          login: boolean
          mustNotCancel: boolean
          globalSales: boolean
          adultAuth: boolean
          parking:
            | ProductConfigControlParking.NO_PARKING_LOT
            | ProductConfigControlParking.WALKING_ONLY
        }
      }
    | {
        roomTypeId: number
        control: {
          reservation: boolean
          login: boolean
          mustNotCancel: boolean
          globalSales: boolean
          adultAuth: boolean
          parking: ProductConfigControlParking.PARKING_AVAILABLE
        }
        // 만차정보 (control.parking = PARKING_AVAILABLE 인 경우 필수)
        parking: {
          full: boolean
          date: string
        }
      }
  )

export interface IGetRatePlanConfigParams {
  ratePlanId: number
  checkInDate: string
}

export type TGetRatePlanConfigResponse = {
  propertyId: number
  roomTypeId: number
  ratePlanId: number
  promotions: string[]
  tags: string[]
  badges: string[]
  filters: string[]
} & (
  | {
      control: {
        parking:
          | ProductConfigControlParking.NO_PARKING_LOT
          | ProductConfigControlParking.WALKING_ONLY
      }
      parking: undefined
    }
  | {
      control: {
        parking: ProductConfigControlParking.PARKING_AVAILABLE
      }
      // 만차정보 (control.parking = PARKING_AVAILABLE 인 경우 필수)
      parking: {
        full: boolean
        date: string
      }
    }
)

export interface GetCancelPoliciesByPolicyIdCheckParams {
  checkInDate?: string
  checkOutDate?: string
  yanoljaTime?: boolean
}

export const CancelPolicyRefundType = {
  /** 전부 환불 */
  FULL: 'FULL',
  /** 일부 환불 */
  PARTIAL: 'PARTIAL',
  /** 환불 불가 */
  NONE: 'NONE',
} as const

export type TCancelPolicyRefundType = keyof typeof CancelPolicyRefundType

export interface CancelPoliciesByPolicyIdCheckResponse {
  id: number
  name?: string
  method: TProductConfigCancelPolicyMethod
  isCancellable: boolean
  refund: {
    type: TCancelPolicyRefundType
    endAt: string
  } | null
  policies: {
    startDays?: number
    startTime?: string
    startOffset?: number
    endDays: number
    endTime: string
    endOffset: number
    criteria: TProductConfigCancelPolicyCriteria
    ratio?: number
  }[]
  createdAt: string
  updatedAt: string
  applyPolicies:
    | {
        startDate: string
        endDate: string
        criteria: TProductConfigCancelPolicyCriteria
        ratio?: number
      }[]
    | null
}

export interface IGetCancelPoliciesCheckParams {
  propertyId: number
  checkInDate: string
  checkOutDate: string
}

export const ProductConfigCancelPolicyMethod = {
  BY_CHECK_IN: 'BY_CHECK_IN',
  BY_DAYS: 'BY_DAYS',
}

export type TProductConfigCancelPolicyMethod = keyof typeof ProductConfigCancelPolicyMethod

export const ProductConfigCancelPolicyCriteria = {
  FREE: 'FREE',
  TOTAL: 'TOTAL',
  RATIO: 'RATIO',
}

export type TProductConfigCancelPolicyCriteria = keyof typeof ProductConfigCancelPolicyCriteria

export interface IProductConfigCancelPolicy {
  id: number
  name?: string
  method: TProductConfigCancelPolicyMethod
  policies: {
    startDays?: number
    startTime?: string
    startOffset?: number
    endDays: number
    endTime: string
    endOffset: number
    criteria: TProductConfigCancelPolicyCriteria
    ratio?: number
  }[]
  createdAt: string
  updatedAt: string
}
